import React from 'react';
import { Box } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";

var Close = function Close(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 16 : _ref$height;
  return /*#__PURE__*/_jsx(Box, {
    as: "svg",
    $styles: {
      width: width,
      height: height
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M4 6L8 10L12 6",
      stroke: "#050038",
      strokeWidth: "2",
      strokeLinecap: "round"
    })
  });
};

export default Close;